import { render, staticRenderFns } from "./EvaluationAssesment.vue?vue&type=template&id=6243441d&"
import script from "./EvaluationAssesment.vue?vue&type=script&lang=js&"
export * from "./EvaluationAssesment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports